module.exports = __webpack_public_path__ + "static/media/Facevook-icon-small.081fc67f.png";